import React from 'react';
import { Play, Check, X } from 'lucide-react';
import type { TriggerAnalysisWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: TriggerAnalysisWidgetData;
}

export const TriggerAnalysisWidget: React.FC<Props> = ({ data }) => {
  const started = data.status === 'started';

  return (
    <div className="mt-1.5 flex items-center gap-2 text-[11px] bg-rose-50/70 dark:bg-rose-900/10 rounded px-2 py-1.5">
      <Play className="h-3 w-3 text-rose-500 dark:text-rose-400 flex-shrink-0" />
      <span className="font-medium text-rose-700 dark:text-rose-300">
        {data.analysisType.replace(/_/g, ' ')}
      </span>
      {started ? (
        <span className="flex items-center gap-1 text-[10px] text-green-600 dark:text-green-400">
          <Check className="h-2.5 w-2.5" />
          Started
        </span>
      ) : (
        <span className="flex items-center gap-1 text-[10px] text-red-600 dark:text-red-400">
          <X className="h-2.5 w-2.5" />
          Failed
        </span>
      )}
    </div>
  );
};
